import appCorporateInvoice from "../../views/appCustomers/corporateinvoice.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("corporateinvoice", {
    url: "corporateinvoice/:id",
    parent: "app",
    views: {
      view: {
        template: appCorporateInvoice,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateInvoice" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/corporateInvoice.urls.js